/**
 * Global offline banner.
 *
 * Previously only the tournament hub (TournamentSummaryPage) told the user
 * they were looking at cached data — every other page went silently stale
 * with no indication offline (persona/UX review #18). This is the
 * connectivity-only slice of that banner (not the hub's page-specific
 * "stale while live" tracking, which doesn't generalize to arbitrary pages)
 * shown app-wide from RootLayout.
 */

import { useOffline } from '../../hooks/useOffline';

export function OfflineBanner() {
  const { isOnline } = useOffline();

  if (isOnline) return null;

  return (
    <div
      className="bg-yellow-500/20 border-b border-yellow-500/30 px-4 py-2"
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-center justify-center gap-2 text-sm text-yellow-400">
        <svg
          className="w-4 h-4 flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414"
          />
        </svg>
        <span>You're offline. Showing cached data where available.</span>
      </div>
    </div>
  );
}

export default OfflineBanner;
